import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";
import { apiCaller } from "../functions";

export function useUserManagementApi() {
    const callApi = useApiCall();
    return{
        //employee types
        getEmployeeTypes: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.GET_EMPLOYEE_TYPES),
        updateEmployeeTypes: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.UPDATE_EMPLOYEE_TYPES),
        deleteEmployeeTypes: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.DELETE_EMPLOYEE_TYPES),

        //pay types
        getPayTypes: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.GET_PAY_TYPES),
        updatePayTypes: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.UPDATE_PAY_TYPES),
        deletePayTypes: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.DELETE_PAY_TYPES),

        //users
        searchUsers: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.SEARCH_USERS),
        insertUpdateUser: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.INSERT_UPDATE_USER),
        deleteUser : apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.DELETE_USER),
        getUserDetails: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.GET_USER_DETAILS),
        getUserSchedule: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.GET_USER_SCHEDULE),
        searchUserSchedule: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.SEARCH_USER_SCHEDULE),
        insertUpdateUserSchedule: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.INSERT_UPDATE_USER_SCHEDULE),
        getUserScheduleById: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.GET_USER_SCHEDULE_BY_ID),
        validateMpin: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.VALIDATE_MPIN),


        //role permissions
        getRolePermission: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.GET_ROLE_PERMISSION),
        getRoleList: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.ROLE_LIST),
        insertUpdateRolePermission: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.INSERT_UPDATE_ROLE_PERMISSION),
        deleteRolePermission: apiCaller(callApi, SAGA_ACTIONS.USER_MANAGEMENT.DELETE_ROLE_PERMISSION),
    }
}